import React, { useState } from "react";
import { IoClose } from "react-icons/io5";

export default function UpdatePopup({ item, onClose }) {
  const [formData, setFormData] = useState({
    title: item?.title || "",
    type: item?.type || "",
    duration: item?.duration || "",
    bodyType: item?.bodyType || "",
    packingStyle: item?.packingStyle || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onClose(); 
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-[20rem] shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-black text-xl"
        >
          <IoClose />
        </button>

        <h2 className="text-xl font-semibold mb-4 text-center">
          Update Details
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Title
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Type
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2"
            >
              <option value="PRO">PRO</option>
              <option value="BASIC">BASIC</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Duration
            </label>
            <input
              type="text"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Body Type
            </label>
            <input
              type="text"
              name="bodyType"
              value={formData.bodyType}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Packing Style
            </label>
            <input
              type="text"
              name="packingStyle"
              value={formData.packingStyle}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md p-2"
            />
          </div>

          <div className="flex flex-col items-center mt-4">
            <button className="px-4 py-2 bg-bgprimary text-white rounded-md">
              Upload
            </button>

            <div className="flex justify-end gap-4 mt-4 w-full">
              <button
                type="button"
                onClick={onClose}
                className="bg-gray-400 text-white px-4 py-2 rounded-md"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
